(function(){
    angular
        .module('appback')
        .directive('ngHemogramainclinic', hemogramainclinic);

        hemogramainclinic.$inject = ['GenerallabService','$uibModal','ResultadosService','$timeout'];
        function hemogramainclinic(GenerallabService,$uibModal,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=hemogramainclinic.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {


                  scope.generalLab = GenerallabService;
                  scope.loading = true;
                  scope.dilucionModal = "";
                  //console.log("hem",scope.item.resultado.extra.resultado);
                  if(!scope.item.resultado){
                      scope.item.resultado = { extra : { resultado : { subanalitica : { created:''} }}};
                  }else{
                    if(!scope.item.resultado.extra){
                      scope.item.resultado.extra = { resultado : {subanalitica : { created:''} }};
                    }else{
                      if(!scope.item.resultado.extra.resultado){
                        scope.item.resultado.extra.resultado = { subanalitica : { created:''}};
                      }else{
                        if(Array.isArray(scope.item.resultado.extra.resultado)){
                          scope.item.resultado.extra.resultado = { subanalitica : { created:''}};
                        }
                       //console.log("resmd");
                       //console.log(scope.item.resultado.extra.resultado);

                      }
                    }
                }
                 
		            	//console.log(scope);
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,false,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
                     for(var cont=0;cont<scope.subanaliticas.length;cont++){
                       if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])=='undefined'){
                         scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa] = { resultado : ''};
                         
                       }
                       scope.subanaliticas[cont].resultado = scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa];
                       scope.generalLab.setInterpretacionesSubanalitica(scope.item,scope.subanaliticas[cont]);
                     }
                    scope.loading = false;
			            });


                  scope.valorNormalidad = function(subanalitica){
                    var resultado = false;
                    //console.log(scope.item.resultado);
                    if(typeof(scope.item.resultado) !='undefined' && typeof(subanalitica.valoresnormalidad)!='undefined'){
                      if(typeof(subanalitica.valoresnormalidad.valor)!='undefined'){
                        var valorNormalidad = subanalitica.valoresnormalidad.valor.split("-");
                        if(typeof(scope.item.resultado.extra)!='undefined' && scope.item.resultado.extra && typeof(scope.item.resultado.extra.resultado.subanalitica) != 'undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa]) != 'undefined'){
                          if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
                            resultado = -1;
                          }else{
                             if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
                                // console.log(parseFloat(subanalitica.resultado.resultado));
                                 //console.log(parseFloat(valorNormalidad[1].trim()));
                                 resultado = 1;
                             }
                          }
                        }
                      }
                    }
                    return resultado;
                            
                  }

			        });
		        }
          }
      }
})();